import type { ReactNode } from 'react';
import { Heading, TextPassage } from '@petsmart-ui/sparky';
import type { TextColor } from '../../types';
import { COLOR_TABLE } from '../../constants';

interface TextProps {
    color?: TextColor;
    children: ReactNode;
    className?: string;
    align?: 'center';
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export function Text({ color: c, as, ...p }: TextProps) {
    const props = {
        style: { ...(c && { color: COLOR_TABLE[c] }) },
        ...p,
    };

    if (as) {
        return <Heading tagName={as} {...props} />;
    }

    return <TextPassage {...props} />;
}
